









































import { SupportFileType } from '@tt4b/ttam-enums';
import { defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-material-upload-select-file-button';

export default defineComponent({
  name,

  props: {
    limit: { type: Number, default: 20 },
    isDrag: { type: Boolean, default: false },
    fileAccept: { type: String, default: SupportFileType.video.join(',') },
  },

  setup(props, { emit }) {
    const uploadBtnNode = ref();
    function onSelectFiles(files: File[]) {
      emit('select', files);
    }
    function clearFiles() {
      uploadBtnNode.value?.clearFiles();
    }
    return {
      onSelectFiles,
      clearFiles,
      uploadBtnNode,
    };
  },
});
